import { Name as EntityName } from '../../entity';

export const TYPE = `${EntityName.ACTION_PREFIX}DIALOG:store_stepper_step`;

export interface Payload {
    w: string; // websiteId
    s: string; // stepperId
    sn: string; // step name
}
